// extracted by mini-css-extract-plugin
export default {"root":"DeleteApiKeyModal_root__mSny9","alertIcon":"DeleteApiKeyModal_alertIcon__KiZY4","warning":"DeleteApiKeyModal_warning__LNKTF","container":"DeleteApiKeyModal_container__Seuj9"};